import Aos from 'aos'

import {Scroll} from '@js/animations/Scroll'
import {Mask} from '@js/animations/Mask'
import {Wipe} from "@js/animations/Wipe";
import {Stagger} from "@js/animations/Stagger";

export class Animation {
  static registerAnimations() {

    /*
      * Register the animations present in "animations" folder
     */
    const animations = [
      Mask,
      Scroll,
      Wipe,
      Stagger
    ]

    animations.forEach(animation => {
      const anim = new animation()
    })

    Aos.init({
      duration: 700,
      easing: 'ease-in-out',
      once: true
    })

  }
}
